import styled from 'styled-components';

export const TagContainer = styled.div`
    margin: 4px;
`;

export const TagTitle = styled.div`
    padding: 0px 12px;
    border-radius: 8px;
    background-color: #e4e8ef;
    border-color: #e4e8ef;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.18;
    letter-spacing: normal;
    text-align: center;
    color: #3c4455;
`;

export const TagList = styled.ul`
    font-size: 12px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6c7485;
    list-style:none;
    padding-left: 8px;
    margin-top: 6px;
`;